/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { Country } from 'src/core/models'
import { getCountryName } from 'src/core/json'

const ProjectInfoCountryContent: React.FC<{ country: Country }> = ({ country }) => {
  return <>
    <img
      src={country?.flag}
      alt={`flag-${country?.name}`}
    />
    <span className='ml-2'>
      {getCountryName(country?.code2, country?.name)}
    </span>
  </>
}

export default ProjectInfoCountryContent
